export const SET_RENEW_CAMPAIGN = 'SET_RENEW_CAMPAIGN'

export const setRenewCampaign = payload => dispatch =>
  dispatch({
    type: SET_RENEW_CAMPAIGN,
    payload: payload
  })
